import React, { useRef } from 'react'
import { inputParameters } from '../constants/constants'
import Input from 'web/src/app/root/components/common/input'
import { Form } from 'web/src/app/root/components/common'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { validationSchema } from '../validation-schema'

const AddressForm = React.forwardRef(({ setFormData, formData }, ref) => {
    const classes = useStyles()
    const { addressSchema } = validationSchema()
    const {
        companyInput,
        firstNameInput,
        lastNameInput,
        addressInput,
        zipCodeInput,
        cityInput,
        countryInput,
        noteInput
    } = inputParameters()

    const handleSubmit = data => {
        setFormData(data)
    }

    return (
        <Form
            ref={ref}
            className={classes.addressForm}
            onSubmit={handleSubmit}
            schema={addressSchema}
            defaultValues={formData}>
            {({ register, formState: { errors } }) => {
                return (
                    <>
                        <Box className={classes.inputGroup}>
                            <Box className={classes.inputWrapper}>
                                <Typography className={classes.fieldTitle}>
                                    {firstNameInput.label}
                                </Typography>
                                <Input
                                    placeholder={firstNameInput.label}
                                    {...register(firstNameInput.register)}
                                    value={formData?.first_name || ''}
                                    isError={!!errors.firstName}
                                    size={'small'}
                                    errorText={errors.firstName?.message}
                                />
                            </Box>
                            <Box className={classes.inputWrapper}>
                                <Typography className={classes.fieldTitle}>
                                    {lastNameInput.label}
                                </Typography>
                                <Input
                                    placeholder={lastNameInput.label}
                                    {...register(lastNameInput.register)}
                                    value={formData?.last_name}
                                    isError={!!errors.lastName}
                                    size={'small'}
                                    errorText={errors.lastName?.message}
                                />
                            </Box>
                        </Box>
                        <Box className={classes.inputWrapper}>
                            <Typography className={classes.fieldTitle}>
                                {companyInput.label}
                            </Typography>

                            <Input
                                placeholder={companyInput.label}
                                {...register(companyInput.register)}
                                value={formData?.company}
                                isError={!!errors.company}
                                size={'small'}
                                errorText={errors.company?.message}
                            />
                        </Box>

                        <Box className={classes.inputWrapper}>
                            <Typography className={classes.fieldTitle}>
                                {addressInput.label}
                            </Typography>
                            <Input
                                placeholder={addressInput.label}
                                {...register(addressInput.register)}
                                isError={!!errors.streetAndNumber}
                                value={formData?.street_address}
                                size={'small'}
                                errorText={errors.streetAndNumber?.message}
                            />
                        </Box>

                        <Box className={classes.inputGroup}>
                            <Box className={classes.inputWrapper}>
                                <Typography className={classes.fieldTitle}>
                                    {zipCodeInput.label}
                                </Typography>
                                <Input
                                    placeholder={zipCodeInput.label}
                                    {...register(zipCodeInput.register)}
                                    isError={!!errors.zipCode}
                                    value={formData?.zip_code}
                                    size={'small'}
                                    errorText={errors.zipCode?.message}
                                />
                            </Box>
                            <Box className={classes.inputWrapper}>
                                <Typography className={classes.fieldTitle}>
                                    {cityInput.label}
                                </Typography>
                                <Input
                                    placeholder={cityInput.label}
                                    {...register(cityInput.register)}
                                    isError={!!errors.city}
                                    size={'small'}
                                    value={formData?.city}
                                    errorText={errors.city?.message}
                                />
                            </Box>
                        </Box>

                        <Box className={classes.inputWrapper}>
                            <Typography className={classes.fieldTitle}>
                                {countryInput.label}
                            </Typography>
                            <Input
                                placeholder={countryInput.label}
                                {...register(countryInput.register)}
                                isError={!!errors.country}
                                value={formData?.country}
                                size={'small'}
                                errorText={errors.country?.message}
                            />
                        </Box>
                        <Box className={classes.inputWrapper}>
                            <Typography className={classes.fieldTitle}>
                                {noteInput.label}
                            </Typography>
                            <Input
                                placeholder={noteInput.label}
                                {...register(noteInput.register)}
                                multiline
                                value={formData?.note}
                                minRows={4}
                                maxRows={8}
                                size={'small'}
                            />
                        </Box>
                    </>
                )
            }}
        </Form>
    )
})
export default AddressForm

const useStyles = makeStyles(theme => {
    return {
        addressForm: {
            padding: '30px 25px 25px 25px',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            borderRadius: theme.borderRadius,
            border: '1px solid #EAECF0',
            boxShadow:
                '0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)'
        },
        inputWrapper: {
            flex: 1,
            paddingBottom: 20
        },
        inputGroup: {
            display: 'flex',
            gap: 36
        },
        fieldTitle: {
            paddingBottom: 5,
            fontSize: '14px',
            fontWeight: 500
        }
    }
})
